import apiClient from './client';

export interface ExportRequest {
  entity_type: 'lead' | 'account' | 'contact' | 'activity' | 'task';
  format: 'csv' | 'excel';
  filters?: any;
  fields?: string[];
}

export interface ExportResponse {
  success: boolean;
  data: {
    fileName: string;
    recordCount: number;
    downloadUrl: string;
  };
}

export const exportApi = {
  export: async (request: ExportRequest): Promise<ExportResponse> => {
    // Standard JSON request
    const response = await apiClient.post<ExportResponse>('/export', request);
    return response.data;
  },
  downloadFile: async (url: string, filename: string): Promise<void> => {
    // Fetch the file as a blob using apiClient to ensure auth headers are sent
    // The url from backend is "/api/export/download/..." but apiClient already has /api as base
    // So we need to strip /api from the beginning if present
    const cleanUrl = url.startsWith('/api') ? url.replace('/api', '') : url;
    try {
      const response = await apiClient.get(cleanUrl, {
        responseType: 'blob'
      });
      
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  },
  downloadSample: async (entityType: 'lead' | 'account' | 'contact' | 'activity' | 'task'): Promise<void> => {
    const response = await apiClient.get(`/export/sample/${entityType}`, {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const filename = `${entityType}_import_template.xlsx`;
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
